<template>
  <footer class="relative bg-gravaawarmgray py-8 lg:py-24 text-gravaadeepbrown">
    <UiContentwrapper class="flex">

      
      <div class="col-span-10 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div class="md:col-span-2 pb-16">
          <Logo v-if="isHomePage" @click="scrollToTop" class="w-44 cursor-pointer" />
          <NuxtLink v-else to="/" aria-label="Home">
            <Logo class="w-44 " />
          </NuxtLink>
        </div>
        <div class="hidden lg:block">
          <UiSocialIcons/>
        </div>
        
        
        <div>
          <!-- homepage logo is scroll to top -->                
          <h4 class="mb-4">Customer Service</h4>
          <ul>
            
            <li v-if="footerMenu" v-for="(menu, index) in footerMenu.items" :key="menu.title" class="mr-9">
              <NuxtLink :to="menuStore.stripDomain(menu.url)" >
                {{ menu.title }}
              </NuxtLink>
            </li>
          </ul>
        </div>
        <!-- col 2-->
        <div>
          <h4 class="mb-4">Company Info</h4>
          <ul>
            <li v-if="companyInfo" v-for="(menu, index) in companyInfo.items" :key="menu.title" class="mr-9">
              <NuxtLink :to="menuStore.stripDomain(menu.url)" >
                {{ menu.title }}
              </NuxtLink>
            </li>
          </ul>
        </div>

        <!-- col 3-->
        <div>          
          <ContactEmailSubscription />
          <div class="block lg:hidden">
            <UiSocialIcons />
          </div>
        </div>

      </div>

          <!-- All rights reserved below -->
          <div class="col-span-10 mt-10 lg:mt-10 text-center lg:text-left flex flex-wrap lg:items-center lg:space-x-4">
            <ul class="flex flex-wrap justify-center lg:justify-start space-x-10">
              <li 
                v-if="policyMenu" 
                v-for="(menu, index) in policyMenu.items" 
                :key="menu.title" 
                class="inline-block text-xs"> <!-- Add sm:text-xs for smaller screens -->
                <NuxtLink :to="menuStore.stripDomain(menu.url)">
                  {{ menu.title }}
                </NuxtLink>
              </li>
            </ul>
          </div>

     
      
    </UiContentwrapper>
  </footer>

</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMenuStore } from "@/stores/menuStore";
const UiSocialIcons = defineAsyncComponent(() => import('@/components/ui/SocialIcons.vue'));
const Logo = defineAsyncComponent(() => import('@/components/Logo.vue'));

// Get the current route
const route = useRoute();


const menuStore = useMenuStore();


// Hämta footermenyn
const { data: footerMenu, error: footerError } = await useAsyncData('footer', async () => {
  return await menuStore.fetchMenuByHandle('footer');
});

// Hämta company-info-menyn
const { data: companyInfo, error: companyInfoError } = await useAsyncData('company-info', async () => {
  return await menuStore.fetchMenuByHandle('company-info');
});

// Hämta policy-menyn
const { data: policyMenu, error: policyError } = await useAsyncData('policy-menu', async () => {
  return await menuStore.fetchMenuByHandle('policy-menu');
});


// Check if the current route is the home page
const isHomePage = computed(() => route.path === '/');


const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
</script>

<style scoped>
footer{
  z-index: 7;
}

/* Gravaadeepbrown color for listitems */
li a {
  color: #563B2F; /* Gravaadeepbrown color */
  text-decoration: none; /* Remove underline */
  transition: color 0.3s ease; /* Smooth transition for hover effect */
}
li a:hover {
  scale: 1.03; /* Scale up on hover */
}
</style>